import { memo, useEffect, useRef } from 'react';
import useIncomingCallAccessDecision from '../../hooks/calls/useIncomingCallAccessDecision';
import shouldDismissUnauthorizedIncoming from '../../hooks/calls/incomingCallVisibilityPolicy';

const QUEUED_CONTEXT = 'queuedWhileActive';

const WaitingIncomingCallAuthorizer = memo(({
  callInfoData,
  updateIncomingPhone,
  onDismiss,
  onAuthorizationResolved
}) => {
  const reportedRef = useRef(false);

  const {
    isAuthorizationReady,
    canViewIncomingCall
  } = useIncomingCallAccessDecision({ callInfoData, updateIncomingPhone });

  useEffect(() => {
    if (!isAuthorizationReady || reportedRef.current) return undefined;

    reportedRef.current = true;
    onAuthorizationResolved?.(callInfoData.callId, canViewIncomingCall);

    if (shouldDismissUnauthorizedIncoming({ canView: canViewIncomingCall, context: QUEUED_CONTEXT })) {
      onDismiss?.(callInfoData.callId);
    }

    return undefined;
  }, [
    isAuthorizationReady,
    canViewIncomingCall,
    callInfoData.callId,
    onAuthorizationResolved,
    onDismiss
  ]);

  return null;
});

WaitingIncomingCallAuthorizer.displayName = 'WaitingIncomingCallAuthorizer';

export default WaitingIncomingCallAuthorizer;
